import { useMutation } from "@apollo/client";

import { PlannerV2ScheduleConfirmDocument } from "../mutations.generated";
import { PlannerV2AreasGetWithPendingChangesDocument } from "../queries.generated";

export default function usePlannerV2ScheduleConfirm() {
    const [mutate, { data, loading, error }] = useMutation(PlannerV2ScheduleConfirmDocument, {
        refetchQueries: [PlannerV2AreasGetWithPendingChangesDocument],
        awaitRefetchQueries: true,
    });

    return {
        /**
         * Confirms pending schedule changes. Omit `plannerVisitIds` to confirm
         * everything; pass a non-empty array to confirm only those visits.
         */
        confirmSchedule: async (plannerVisitIds?: string[]) => {
            await mutate({ variables: { input: plannerVisitIds ? { plannerVisitIds } : null } });
        },
        data,
        loading,
        error,
    };
}
